import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SendIcon from "@mui/icons-material/Send";
import newRequest from "../../../../utils/newRequest";
import { useTranslation } from "react-i18next";

const UpdateLanguage = ({ isVisible, setVisibility, refreshData, onSuccess, onError }) => {
  const { t, i18n } = useTranslation();
  const updateData = JSON.parse(
    sessionStorage.getItem("updateLanguageSection") || "{}"
  );

  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const [nl, setNl] = useState("");
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    setKey(updateData?.key || "");
    setValue(updateData?.value || "");
    setNl(updateData?.nl || "");
  }, [updateData?.id]);

  const handleCloseUpdatePopup = () => {
    setVisibility(false);
  };

  const handleUpdateLanguage = async () => {
    setLoading(true);
    setLocalError(null);
    try {
      const response = await newRequest.put(
        `/updateLanguageById/${updateData?.id}`,
        {
          key,
          value,
          nl,
        }
      );
      // API returns { message: "Language updated successfully" } on success
      const successMessage =
        response?.data?.message || `${t("Language")} ${t("has been")} ${t("Updated Successfully")}.`;
      if (onSuccess) onSuccess(successMessage);
      refreshData();
      handleCloseUpdatePopup();
    } catch (err) {
      const errMsg =
        err?.response?.data?.error || err?.message || t("Something went wrong");
      if (onError) onError(errMsg);
      else setLocalError(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {localError && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] px-4 py-2 bg-red-100 border border-red-400 text-red-700 rounded shadow">
          {localError}
        </div>
      )}
      {isVisible && (
        <div className="popup-overlay z-50">
          <div className="popup-container h-auto sm:w-[45%] w-full">
            <div
              className="popup-form w-full"
              style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
              <form className="w-full">
                <h2
                  className={`text-secondary font-sans font-semibold text-2xl ${
                    i18n.language === "ar" ? "text-end" : "text-start"
                  }`}
                >
                  {t("Edit")} {t("Language")}
                </h2>
                <div className="flex flex-col sm:gap-3 gap-3 mt-5">
                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="key"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Key")}
                    </label>
                    <input
                      type="text"
                      id="key"
                      value={key}
                      onChange={(e) => setKey(e.target.value)}
                      placeholder={t("Enter Key")}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="value"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Value")}
                    </label>
                    <input
                      type="text"
                      id="value"
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      placeholder={t("Enter Value")}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="nl"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      NL
                    </label>
                    <input
                      type="text"
                      id="nl"
                      value={nl}
                      onChange={(e) => setNl(e.target.value)}
                      placeholder={t("Enter NL")}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>
                </div>

                <div className="w-full flex justify-center items-center gap-8 mt-5">
                  <button
                    type="button"
                    className="px-5 py-2 w-[30%] rounded-sm bg-primary text-white font-body text-sm"
                    onClick={handleCloseUpdatePopup}
                  >
                    {t("Close")}
                  </button>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#021F69", color: "#ffffff" }}
                    onClick={handleUpdateLanguage}
                    disabled={loading}
                    className="w-[70%] ml-2"
                    endIcon={
                      loading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        <SendIcon />
                      )
                    }
                  >
                    {t("Update")} {t("Language")}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateLanguage;
